import React, { lazy, Suspense } from 'react';
import { AcceptedDexValues } from 'src/common/constants';
import ErrorBoundary from 'src/components/Errors/ErrorBoundary';
import Loader from 'src/components/Loader/Loader';
import 'src/components/App/App.scss';
// webpack dynamic imports vs React.lazy
// https://stackoverflow.com/questions/61804283/using-react-lazy-vs-webpack-dynamic-imports
const DesignStackPrintExtended = lazy(
  () =>
    import(
      'src/components/Design-Stack/DesignStackPrintExtended' /* webpackChunkName: "print-extended" */
    )
);

// ErrorBoundary and Suspense as suggested here: https://en.reactjs.org/docs/code-splitting.html
const App = (props: { dex: string | null; dexData: any; locale: string }) => {
  return (
    <ErrorBoundary locale={props.locale}>
      <Suspense fallback={<Loader />}>
        {props.dex === AcceptedDexValues.PRINT_EXTENDED && (
          <DesignStackPrintExtended dexData={props.dexData} locale={props.locale} />
        )}
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
